import React from "react";

import {
  Button,
  Content,
  Grid,
  GridItem,
  Stack,
  StackItem
} from "@patternfly/react-core";

import { SectionPanel } from "shared/components/SectionPanel";
import { TechStack } from "./techstack";
import useAppearance from "shared/appearance/hooks/useAppearance";
import { getResolvedLogosByIds } from "shared/services/logosService";

const EduPanel = ({
  isCard = false,
  showHeader = true,
  showAction = true,
  isCarousel = false,
  title = "...",
  description = "...",
  actionLabel = ".........",
  actionHref = null,
  hero = null,
  logos = []
}) => {
  const { colorScheme } = useAppearance();
  const eduLogos = getResolvedLogosByIds({
    logos,
    colorScheme,
    ids: [
      "education-platform"
    ]
  });
  const action =
    showAction && actionHref ? (
      <Button
        variant="primary"
        component="a"
        href={actionHref}
        target="_blank"
        rel="noopener noreferrer"
      >
        {actionLabel}
      </Button>
    ) : null;

  return (
    <SectionPanel
      logos={eduLogos}
      logosClickable={false}
      isCard={isCard}
      action={action}
    >
      <Stack hasGutter>
        {showHeader && (title || description) && (
          <StackItem>
            <Grid>
              <GridItem
                span={10}
                offset={1}
                lg={8}
                lgOffset={2}
              >
                <Stack hasGutter>
                  {title && (
                    <StackItem>
                      <Content
                        component="h1"
                        style={{ textAlign: "center" }}
                      >
                        {title}
                      </Content>
                    </StackItem>
                  )}

                  {description && (
                    <StackItem>
                      <Content
                        component="p"
                        style={{ textAlign: "center" }}
                      >
                        {description}
                      </Content>
                    </StackItem>
                  )}
                </Stack>
              </GridItem>
            </Grid>
          </StackItem>
        )}

        {hero && (
          <StackItem>
            {hero}
          </StackItem>
        )}

        <StackItem>
          <TechStack />
        </StackItem>
      </Stack>
    </SectionPanel>
  );
};

export default EduPanel;